import React from "react";
import { TRAIL, PLACES, getPlace, getRegion, placeState } from "../../lib/scaleCountry";

const MAP_W = 680;
const MAP_H = 330;

const REGION_LABELS = [
  { text: "Pentatonic Foothills", x: 40, y: 296 },
  { text: "Modal Plains", x: 300, y: 160 },
  { text: "The Weird Coast", x: 440, y: 26 },
  { text: "Harmonic Highlands ~ fog", x: 110, y: 122 },
];

const trailPoints = TRAIL.map((id) => {
  const place = getPlace(id);
  return `${place.map.x},${place.map.y}`;
}).join(" ");

// stamped is fully filled, visited is half-filled (a little "you've been
// here but haven't left a phrase yet" tell), new is outline-only.
const pipFill = (state) => {
  if (state === "stamped") return { background: "#A6C46A" };
  if (state === "visited")
    return { background: "linear-gradient(90deg, #A6C46A 50%, transparent 50%)" };
  return { background: "transparent" };
};

/* ============================================================
   CountryMap — the trail is drawn once as a dotted polyline
   through the (non-fog) TRAIL places; every PLACE gets its own
   pip on top, fog-region pips rendered dimmer since they're not
   part of the guided path.
   ============================================================ */

const CountryMap = ({ progress, selectedId, onSelect }) => {
  return (
    <div className="overflow-x-auto">
      <div
        className="relative rounded-lg border border-[#39432F]"
        style={{
          width: MAP_W,
          height: MAP_H,
          background: "#222B20",
          backgroundImage:
            "repeating-radial-gradient(circle at 85% 110%, transparent 0, transparent 42px, #28331F 42px, #28331F 43px)",
        }}
      >
        <svg
          className="absolute left-0 top-0"
          width={MAP_W}
          height={MAP_H}
          aria-hidden="true"
        >
          <polyline
            points={trailPoints}
            fill="none"
            stroke="#4A5443"
            strokeWidth={2}
            strokeDasharray="2 7"
          />
        </svg>

        {REGION_LABELS.map(({ text, x, y }) => (
          <div
            key={text}
            className="pointer-events-none absolute font-serif text-sm italic text-[#79855F]"
            style={{ left: x, top: y }}
          >
            {text}
          </div>
        ))}

        {PLACES.map((place) => {
          const state = placeState(progress, place.id);
          const isFog = Boolean(getRegion(place.regionId)?.fog);
          const selected = selectedId === place.id;
          return (
            <button
              key={place.id}
              type="button"
              aria-label={place.name}
              onClick={() => onSelect(place)}
              className="absolute flex flex-col items-center gap-1"
              style={{
                left: place.map.x,
                top: place.map.y,
                transform: "translate(-50%, -50%)",
              }}
            >
              <span
                className="block rounded-full border-2"
                style={{
                  width: 18,
                  height: 18,
                  borderColor: isFog ? "#4A5443" : "#A6C46A",
                  opacity: isFog ? 0.55 : 1,
                  boxShadow: selected ? "0 0 0 3px #E0A458" : undefined,
                  ...pipFill(state),
                }}
              />
              <span className="font-mono text-[10px] lowercase tracking-wide text-[#97A18B]">
                {place.name.split(" ")[0]}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CountryMap;
